/**
 * Контекст приложения
 */
export const appContext = {
    isDev: process.env.NODE_ENV !== 'production',
    isProd: process.env.NODE_ENV === 'production',
}